var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"enhanced-editor-container",class:{ 'enhanced-editor-container--sticky-toolbar': _vm.stickyToolbar }},[_c('vue-editor',{ref:"vueEditor",attrs:{"id":_vm.id,"placeholder":_vm.placeholder,"editor-toolbar":_vm.customToolbar},on:{"input":_vm.onEditorInput,"ready":_vm.onEditorReady}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }